<template>
  <div class="box12-page">
    <div class="fcp-title">常见问题</div>
    <ul :style="{height: openFlag && 'auto' }">
      <li v-for="(item, index) in list" :key="index" @click="zixun(2,item)">
        <i></i>
        <span>{{ item }}</span>
      </li>
      <div class="mask-box" v-if="!openFlag" @click="openFlag = !openFlag">
        <span>查看全部</span>
        <i></i>
      </div>
    </ul>
    <div class="btn-box">
      <div class="btn" @click="zixun(1,'了解更多')">了解更多</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: '',
    data() {
      return {
        openFlag: false,
        list: [
          'FCP认证难度大吗？如何备考？',
          'FCP认证多少分及格？',
          'FCP认证考试通过后证书在哪领取？',
          'FCP认证考试有面试环节吗？',
          '认证证书有效期多久，过期了怎么办？',
          '认证考试何时可知道考试结果？',
          'FCP认证考试是否有补考？',
          'FCP认证考试时间安排是怎样的？',
        ]
      }
    },
    methods:{
      zixun(type,item){
        type==1?  this.mai("帆软FCP认证&培训","了解更多",0,null): this.mai("帆软FCP认证&培训",item,0,null)
        this.clickZiXun()
      }
    }
  }
</script>

<style lang="scss" scoped>
.box12-page{
  padding: 80px 0 88px;
  background-image: url(../../../assets/coursePage/fcp/box12/box12-bg.png);
  background-size: cover;
  ul{
    width: 686px;
    margin: 48px auto 0;
    position: relative;
    height: 466px;
    overflow: hidden;
    padding: 0 32px;
    background: #FFFFFF;
    box-shadow: 0px 6px 18px 0px rgba(94,123,218,0.08), 0px 4px 6px -4px rgba(94,123,218,0.12);
    border-radius: 12px;
    box-sizing: border-box;
    li{
      padding: 32px 0;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E6EBED;
      i{
        width: 40px;
        height: 40px;
        background-image: url(../../../assets/coursePage/fcp/box12/icon-q.png);
        background-size: 100% 100%;
        margin-right: 16px;
        margin-left: -8px;
        transform: translateY(2px);
      }
      span{
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #1D2129;
        line-height: 44px;
      }
      &:last-child{
        border: 0;
      }
    }
    .mask-box{
      z-index: 1;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 124px;
      background-image: linear-gradient( rgba(255, 255, 255, .3 ), rgba(255, 255, 255, 1 ), rgba(255, 255, 255, 1 ));
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 40px;
      box-sizing: border-box;
      span{
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #86909C;
        line-height: 36px;
      }
      i{
        width: 32px;
        height: 32px;
        background-image: url(../../../assets/coursePage/fcp/box12/icon-open.png);
        background-size: 20px 20px;
        background-position: center;
        background-repeat: no-repeat;
        margin-left: 8px;
      }
    }
  }
  .btn-box{
    margin-top: 48px;
    display: flex;
    justify-content: center;
    .btn{
      width: 686px;
      height: 96px;
      background: linear-gradient(270deg, #98BDFF 0%, #4386FE 100%);
      border-radius: 48px;
      font-size: 30px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 96px;
      text-align: center;
    }
  }
}
</style>